import { React, useEffect, useState } from 'react';
import { useTranslation } from './LocalizationProvider';
import { useCatch } from '../../reactHelper';
import { handleErrorResponse } from '../util/utils';
import CopyableText from './CopyableText';

const AddressValue = ({ latitude, longitude, originalAddress, onClick }) => {
  const t = useTranslation();
  const [address, setAddress] = useState();

  const showAddress = useCatch(async () => {
    const query = new URLSearchParams({ latitude, longitude });
    const response = await fetch(`/api/server/geocode?${query.toString()}`);
    if (response.ok) {
      setAddress(await response.text());
    } else {
      await handleErrorResponse(response);
    }
  });

  useEffect(() => {
    if (originalAddress == null) {
      showAddress();
      setAddress(t('sharedLoading'));
    } else {
      setAddress(originalAddress);
    }
  }, [latitude, longitude, originalAddress]);

  // Remove country code only if it's US
  const formatAddress = (addressStr) => {
    if (!addressStr || addressStr === t('sharedLoading')) {
      return addressStr;
    }

    const lastCommaIndex = addressStr.lastIndexOf(',');
    if (lastCommaIndex === -1) {
      return addressStr;
    }

    // Make sure we're not returning an empty string
    const beforeComma = addressStr.substring(0, lastCommaIndex).trim();
    return beforeComma || addressStr; // If empty, return the full address
  };

  if (address) {
    return (
      <CopyableText text={formatAddress(address)} onClick={onClick} />
    );
  }

  return '';
};

export default AddressValue;
